/**
 * Created by ianva on 2016/7/15.
 */

module.exports = require("./notify");



/** WEBPACK FOOTER **
 ** ./script/cutil/gin-notify/gin-notify.js
 **/